import type { RouteObject } from 'react-router-dom';
import { dashboardRoutes } from './dashboard.routes';
import { eventRoutes } from './event.routes';
import { fullScreenRoutes } from './fullScreen.routes';
import { guestRoutes } from './guest.routes';
import { myRoutes } from './my.routes';
import { operationRoutes } from './operation.routes';
import { partnerRoutes } from './partner.routes';
import { systemRoutes } from './system.routes';

export const guestRouteModules: RouteObject[] = [guestRoutes];

export const appRouteModules: RouteObject[] = [
	dashboardRoutes,
	operationRoutes,
	partnerRoutes,
	eventRoutes,
	systemRoutes,
	myRoutes,
];

export const fullScreenRouteModules: RouteObject[] = fullScreenRoutes;
